export default __webpack_public_path__ + "static/media/clinic-build.a77f9fd6.png";